import { Routes } from '@angular/router';

export const ADMIN_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    loadComponent: () => import('../../pages/admin/dashboard/dashboard').then(m => m.Dashboard),
  },
  {
    path: 'users',
    loadChildren: () => import('../../pages/admin/users/user.routes').then(m => m.USER_ROUTES),
  },
  {
    path: 'wallets',
    loadChildren: () => import('../../pages/admin/wallets/wallet.routes').then(m => m.WALLET_ROUTES),
  },
   {
    path: 'deposit',
    loadChildren: () =>
      import('../../pages/admin/deposit/deposit.routes')
        .then(m => m.DEPOSIT_ROUTES),
  },
  {
    path: 'roles',
    loadChildren: () => import('../../pages/admin/roles/role.routes').then(m => m.ROLE_ROUTES),
  },
  {
    path: 'settings',
    loadChildren: () => import('../../pages/admin/settings/settings.routes').then(m => m.SETTINGS_ROUTES),
  },
   {
    path: 'profile',
    loadChildren: () =>
      import('../../pages/admin/profile/profile.routes')
        .then(m => m.PROFILE_ROUTES),
  },
   {
    path: '2FA',
    loadChildren: () =>
      import('../../pages/admin/2FA/twofac.routes')
        .then(m => m.TWOFAC_ROUTES),
  },
    {
    path: 'exchangeRate',
    loadChildren: () =>
      import('../../pages/admin/exchangeRate/rate.routes')
        .then(m => m.RATE_ROUTES),
  },
     {
    path: 'card',
    loadChildren: () =>
      import('../../pages/admin/cards/card.routes')
        .then(m => m.CARD_ROUTES),
  },
  {
    path: 'kyc',
    loadChildren: () =>
      import('../../pages/admin/kyc/kyc.routes')
        .then(m => m.KYC_ROUTES),
  },
  {
    path: 'staff',
    loadChildren: () =>
      import('../../pages/admin/staff/staff.routes')
        .then(m => m.STAFF_ROUTES),
  },
  {
    path: 'card-webhooks',
    loadChildren: () =>
      import('../../pages/admin/onafriq-webhooks/onafriq-webhook.routes')
        .then(m => m.ONAFRIQ_WEBHOOK_ROUTES),
  },
  {
    path: 'notifications',
    loadChildren: () =>
      import('../../pages/admin/notifications/notification.routes')
        .then(m => m.NOTIFICATION_ROUTES),
  },
  {
    path: 'payouts',
    loadChildren: () =>
      import('../../pages/admin/payouts/payout.routes')
        .then(m => m.PAYOUT_ROUTES),
  },
  {
    path: 'card-transfers',
    loadChildren: () =>
      import('../../pages/admin/card-transfers/card-transfer.routes')
        .then(m => m.CARD_TRANSFER_ROUTES),
  },
];